<script setup>
import Back from '@i/bg-category-select.svg';
import {Link} from '@inertiajs/vue3';
import {useKeenSlider} from "keen-slider/vue";
import {inject, onMounted, ref} from "vue";

const route = inject('route');

defineProps({
    categories: {
        type: Array,
    },
});

const WheelControls = (slider) => {
  let touchTimeout
  let position
  let wheelActive

  function dispatch(e, name) {
    position.x -= e.deltaX
    position.y -= e.deltaY
    slider.container.dispatchEvent(
      new CustomEvent(name, {
        detail: {
          x: position.x,
          y: position.y,
        },
      })
    )
  }

  function wheelStart(e) {
    position = {
      x: e.pageX,
      y: e.pageY,
    }
    dispatch(e, "ksDragStart")
  }

  function wheel(e) {
    dispatch(e, "ksDrag")
  }

  function wheelEnd(e) {
    dispatch(e, "ksDragEnd")
  }

  function eventWheel(e) {
    e.preventDefault()
    if (!wheelActive) {
      wheelStart(e)
      wheelActive = true
    }
    wheel(e)
    clearTimeout(touchTimeout)
    touchTimeout = setTimeout(() => {
      wheelActive = false
      wheelEnd(e)
    }, 50)
  }

  slider.on("created", () => {
    slider.container.addEventListener("wheel", eventWheel, {
      passive: false,
    })
  })
}

const [container] = useKeenSlider({
    loop: true,
    slides: {perView: 2.4},
    breakpoints: {
        '(min-width: 640px)': {
            slides: {perView: 3.5, spacing: 32},
        },
        '(min-width: 768)': {
            slides: {perView: 3.5, spacing: 32},
        },
       
    },
}, [WheelControls])
const loaded = ref(false);

onMounted(() => {
    loaded.value = true;
})


</script>

<template>
    <div
        ref="container"
        :class="{'opacity-0' : !loaded}"
        class="keen-slider flex overflow-hidden transition-opacity duration-300"
    >
        <div
            v-for="(category,i) in categories"
            :key="category.id"
            class="keen-slider__slide"
        >
            <div
                class="ml-2 lg:m-0"
                :class="{'mr-2' : i === categories.length -1}"
            >
                <Link
                    :href="route('public.categories.show', category.page_slug)"
                    class="flex-center relative min-h-10 rounded text-sm font-bold uppercase italic text-white lg:min-h-32 lg:text-xl"
                >
                    {{ category.title }}
                    <img
                        class="absolute inset-y-0  right-0 z-[-1] size-full  object-contain object-right"
                        :src="Back"
                        alt="first nutrition"
                    >
                    <img
                        class="absolute inset-y-0  z-[-1] size-full  object-contain object-center"
                        :src="Back"
                        alt="first nutrition"
                    >
                    <img
                        class="absolute inset-y-0  left-0 z-[-1] size-full  object-contain object-left"
                        :src="Back"
                        alt="first nutrition"
                    >
                </Link>
            </div>
        </div>
    </div>
</template>

